import { httpCreate } from './http';

const http = httpCreate('/srv/official-template');

export const officialTemplate = {
	// 获取公众号模板配置
	getInfo() {
		return http.get('');
	},
	// 修改公众号模板配置
	setInfo(body) {
		return http.post('', body);
	},
	// 添加模板-订阅消息--开播提醒
	subscriptionRemind() {
		return http.post('/subscriptionRemind');
	},
	// 添加模板-订阅消息-报名审核
	subscriptionSign() {
		return http.post('/subscriptionSign');
	},
	// 添加模板-模板消息-开播提醒
	templateRemind() {
		return http.post('/templateRemind');
	},
};
